/* eslint-disable sort-keys */
/* eslint-disable import/prefer-default-export */
import React from 'react'

import { fromRTFtoString } from '../../utils/helpers'

const getSchemaOrgJSONLD = ({
  categories,
  date,
  description,
  pageType,
  title,
  treatment,
  // image,
  treatments,
  url,
}) => {
  const schemaOrgJSONLD = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url,
    name: 'Essential Aesthetics',
    alternateName: 'Essential Aesthetics',
    description,
  }
  if (pageType === 'homepage') {
    return [
      schemaOrgJSONLD,
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url,
        name: 'Essential Aesthetics',
        alternateName: 'Essential Aesthetics',
      },
    ]
  }

  if (pageType === 'treatments') {
    const itemList = []
    categories.forEach((item) => itemList.push(...item.treatments))
    return [
      schemaOrgJSONLD,
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: itemList.map((item, idx) => {
          return {
            '@type': 'ListItem',
            name: item.title,
            position: idx,
            url: `${process.env.GATSBY_URL}/${item.taxonomy.uri}/`,
          }
        }),
      },
    ]
  }

  if (pageType === 'category') {
    return [
      schemaOrgJSONLD,
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: treatments.map((item, idx) => {
          return {
            '@type': 'ListItem',
            name: item.treatmentfeatureddata.featuredname,
            position: idx,
            url: `${process.env.GATSBY_URL}/${item.taxonomy.uri}/`,
          }
        }),
      },
    ]
  }

  if (pageType === 'treatment') {
    return [
      schemaOrgJSONLD,
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: treatment.name,
        // image: `${process.env.GATSBY_URL}/${treatment?.image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}` || '',
        description,
        offers: treatment.offers.map((item) => {
          return {
            '@type': 'Offer',
            name: item.pricecardtitle,
            itemCondition: 'https://schema.org/NewCondition',
            price: fromRTFtoString(item.pricecardprice),
            priceCurrency: 'EUR',
            availability: 'https://schema.org/InStock',
          }
        }),
      },
    ]
  }
  if (pageType === 'blogpost') {
    return [
      schemaOrgJSONLD,
      {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: title,
        description,
        // image: `${process.env.GATSBY_URL}/${image?.images.fallback.src}`,
        datePublished: date,
        publisher: {
          '@type': 'Organization',
          name: 'Essential Aesthetics',
          logo: {
            '@type': 'ImageObject',
            url: `${process.env.GATSBY_URL}/static/logo.png`,
          },
        },
        author: {
          '@type': 'Organization',
          name: 'Essential Aesthetics',
        },
      },
    ]
  }

  if (pageType === 'blogpost') {
    return [
      schemaOrgJSONLD,
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: [],
      },
    ]
  }

  return {
    ...schemaOrgJSONLD,
  }
}

export const SEOComponent = ({
  canonical,
  categories = [],
  date = '',
  description,
  image,
  keywords,
  lang,
  metaTitle,
  ogDescription,
  ogTitle,
  pageType,
  title,
  treatment = {},
  treatments = [],
}) => {
  const uri = canonical === '/' ? '' : canonical
  const url = `${process.env.GATSBY_URL}${uri}`
  return (
    <>
      <meta charSet="UTF-8" />
      <meta content="width=device-width, initial-scale=1.0" name="viewport" />
      {lang && <html lang={lang} />}
      {title && <title>{title}</title>}
      {ogTitle && <meta content={ogTitle} name="twitter:title" />}
      {ogTitle && <meta content={ogTitle} property="og:title" />}
      {metaTitle && <meta content={metaTitle} name="title" />}
      {description && <meta content={description} name="description" />}
      {ogDescription && (
        <meta content={ogDescription} name="twitter:description" />
      )}
      {ogDescription && (
        <meta content={ogDescription} property="og:description" />
      )}
      {keywords && <meta content={keywords} name="keywords" />}
      {canonical && <link href={url} rel="canonical" />}
      {canonical && <meta content={url} name="twitter:url" />}
      {canonical && <meta content={url} property="og:url" />}
      {image && (
        <meta
          content={`${process.env.GATSBY_URL}${image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}`}
          name="twitter:image"
        />
      )}
      {image && (
        <meta
          content={`${process.env.GATSBY_URL}${image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}`}
          property="og:image"
        />
      )}
      {image && (
        <meta
          content={image.altText || 'Image description'}
          property="og:image:alt"
        />
      )}
      {image && (
        <meta
          content={image.altText || 'Image description'}
          name="twitter:image:alt"
        />
      )}
      <meta content="website" property="og:type" />
      <meta content="Essential Aesthetics" property="og:site_name" />
      <meta content={lang || 'nl_NL'} property="og:locale" />
      <meta content="summary_large_image" name="twitter:card" />
      <meta content="index, follow" name="robots" />
      <script type="application/ld+json">
        {JSON.stringify(
          getSchemaOrgJSONLD({
            url,
            description,
            pageType,
            categories,
            treatments,
            treatment,
            // image,
            title,
            date,
          }),
        )}
      </script>
    </>
  )
}
